import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import DocumentVerification from '../../../components/siteadmin/DocumentVerification';
import showAllDocumentQuery from '../../../components/siteadmin/DocumentVerification/showAllDocumentQueryFile.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './Document.css';
class Document extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
    };
    this.setStateVariable = this.setStateVariable.bind(this);
  }

  setStateVariable(variables) {
    this.setState(variables)
  }

  render() {
    const { currentPage, searchList } = this.state;
    const { showAllDocument: { loading } } = this.props;

    return <DocumentVerification
      currentPage={currentPage}
      searchList={searchList}
      setStateVariable={this.setStateVariable}
      isLoading={loading}
    />;
  }

}
export default compose(
  withStyles(s),
  withQuery(showAllDocumentQuery, {
    name: 'showAllDocument',
    options: {
      variables: {
        currentPage: 1,
        searchList: "",
      },
      fetchPolicy: 'network-only',
      ssr: false
    }
  }),
)(Document);